import { useEffect } from 'react'
import { SOURCE_STEP } from '../constants/citationFlow'
import { defaultSourceType } from '../utils/sourceTypes'
import { CitationFlowStep } from '../types/citation-flow'
import { SourceType, Source } from '../types/core'

interface UseCitationFlowArgs {
  step: CitationFlowStep
  sourceType: SourceType
  onChangeSourceType: (sourceType: SourceType) => void
  onSelectSource: (source?: Source) => void
}

const useCitationFlowStepChange = ({
  step,
  sourceType,
  onChangeSourceType,
  onSelectSource,
}: UseCitationFlowArgs) => {
  useEffect(() => {
    // forward user to form if they select manual sourceType
    if (step === SOURCE_STEP && sourceType.manual) {
      onSelectSource()
    }
  }, [step, sourceType])

  useEffect(() => () => onChangeSourceType(defaultSourceType), [onChangeSourceType])
}

export default useCitationFlowStepChange
